/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {BaseComponent, DamElasticDTO, IdAndHeader} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {DAM_SHARE_FORM} from './dam-unit-items-forms.config';

@Component({
  selector: 'app-dam-unit-items',
  templateUrl: './dam-unit-items.component.html',
  styleUrls: ['./dam-unit-items.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamUnitItemsComponent extends BaseComponent implements OnInit {
  title = 'Объединить';
  protected uri = '/dam-unit/items';
  absolutePath = '/cabinet/dam-unit';
  editName: string;
  protected config: CrudConfig = {
    uri: this.uri,
    columns: DAM_SHARE_FORM,
    title: this.title,
    absolutePath: this.absolutePath,
  };

  @Input()
  damItems: DamElasticDTO[] = [];

  damItemsSelect: IdAndHeader[] = [];
  countAllDamVersion: number = 0;
  selectedDamItemID: number;

  ngOnInit(): void {
    console.log(this.damItems);
    this.damItems.forEach(damItem => {
      let idAndHeader = <IdAndHeader> {};
      idAndHeader.id = damItem.id;
      idAndHeader.header = damItem.header + ' (' + damItem.countVersion + ')';
      this.countAllDamVersion += damItem.countVersion;
      this.damItemsSelect.push(idAndHeader);
    });
    this.cdr.detectChanges();
  }

  changeSelected($event) {
    console.log($event);
    console.log(this.selectedDamItemID);
    this.cdr.detectChanges();
  }

  unitItems() {
    let itemsForUnitIds: number[] = [];
    let itemsForUnit = this.damItems.filter(item => {
      if (item.id != this.selectedDamItemID) {
        return item.id;
      }
    });

    itemsForUnit.forEach(item => {
      itemsForUnitIds.push(item.id);
    });
    if (this.selectedDamItemID > 0) {

      this.compoApiService.post('/dam/items/unit', {
        damItemId: this.selectedDamItemID,
        damItemIds: itemsForUnitIds
      }).pipe(take(1), catchError(err => this.handleError(err))).subscribe();
    }
    this.cdr.detectChanges();
  }

}
